import { Component, OnInit } from '@angular/core';
import { default as swal } from 'sweetalert2';

import { AuthService } from '../../../providers/auth.service';
import { SharedClientCandidateService } from '../shared/services/shared-candidate.service';
import { SharedHackService } from '../shared/services/shared-hack.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

export class HackResultsComponent implements OnInit {
	public hackResults: any = null;
	public hackReports: any = null;
	public candidate: any = null;
	public uiEventsReport: any = {};
	public credentials: any = {};

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private authService: AuthService,
		private sharedClientCandidateService: SharedClientCandidateService,
		private sharedHackService: SharedHackService) {}

	public ngOnInit() {
		this.credentials = {
			...this.credentials,
			...this.route.snapshot.params,
			clientId: String(this.authService.userId)
		};
		this.getDeps();
	}

	private getDeps() {
		Observable.forkJoin([
			this.sharedClientCandidateService.getByUuid(this.credentials.clientId, this.credentials.candidateUuid, '', 'hack-result'),
			this.sharedHackService.getHackByUuid(this.credentials.clientId, this.credentials.hackUuid)
		]).subscribe(
			([candidate, hack]) => {
				this.credentials.candidateId = candidate.id;
				this.credentials.hackId = hack.id;
				this.candidate = candidate;

				this.getHackResults();
				this.getHackReports();
			},
			() => this.router.navigate(['/not-found'])
		);
		this.getHackUiEvents();
	}

	private getHackResults(): void {
		this.sharedHackService.getHackResults(this.credentials.clientId, this.credentials.candidateId, this.credentials.hackId).subscribe(
			(results) => this.hackResults = results,
			(error) => {
				this.router.navigate(['/not-found']);
				if (error.status === 402) {
					swal({
						title: `No credits available`,
						text: `You cannot view hack results!`,
						type: 'error',
						showCancelButton: false,
						showConfirmButton: false,
					}).then(() => undefined);
				}
			}
		);
	}

	private getHackUiEvents(): void {
		this.sharedHackService.getHackUiEvents(this.credentials.clientId, this.credentials.candidateUuid, this.credentials.hackUuid).subscribe(
			(report) => {
				if (!report) {
					return;
				}

				const reportMap = {stats: report.stats};
				report.challenges_events.forEach((challenge) => {
					if (!reportMap[challenge.challenge_type]) {
						reportMap[challenge.challenge_type] = {};
					}

					reportMap[challenge.challenge_type][challenge.challenge_id] = {
						stats: challenge.stats,
						events: challenge.events
					};
				});
				this.uiEventsReport = reportMap;
			},
			() => this.router.navigate(['/not-found'])
		);
	}

	private getHackReports(): void {
		this.sharedHackService.getHackReports(this.credentials.clientId, this.credentials.candidateId, this.credentials.hackId).subscribe(
			(reports) => {
				this.hackReports = reports;
			},
			() => this.router.navigate(['/not-found'])
		);
	}
static ctorParameters() { return [ { type: ActivatedRoute }, { type: Router }, { type: AuthService }, { type: SharedClientCandidateService }, { type: SharedHackService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/hack-results/hack-results.component.ts